import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=641b50c2&scoped=true&"
import script from "./Trigger.vue?vue&type=script&lang=js&"
export * from "./Trigger.vue?vue&type=script&lang=js&"
import style0 from "./Trigger.vue?vue&type=style&index=0&id=641b50c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b50c2",
  null
  
)

export default component.exports